import { handleGetColecction, handleSelectedFirebase } from '@/constantes/helpers'
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
import { FILTROS_REPORTE } from '@/constantes/reportes'

/**
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} docRef
 * @param {FILTROS_REPORTE} filtros
 */
 const obtenerFiltrosAdicionalesCortesCaja = (docRef, filtros) => {
  
  const {sucursal, colaborador } = filtros.filtro2

  docRef = handleSelectedFirebase(docRef,sucursal,'id_sucursal')
  docRef = handleSelectedFirebase(docRef,colaborador,'info.id_responsable')

  return docRef

}

const store = {
  state: {
    caja: {},
    indicesCortesCaja: {},
  },
  getters: {
    cajaSeleccionada: state => {
      return state.caja
    },
    indicesCortesCaja: state => {
      return state.indicesCortesCaja;
    },
    noTieneCortesDeCaja: (state, getters) => {

      console.log("Corte caja ", getters.usuario.info_complementaria)

      return getters.usuario.info_complementaria.id_corte_actual===undefined 
          || getters.usuario.info_complementaria.id_corte_actual === null

    }
  },
  mutations: {
    ASIGNA_CAJA(state, caja) {
      state.caja = caja
    },
    ASIGNA_INDICES_CORTES_CAJA(state, cortes){
      state.indicesCortesCaja = cortes;
    }
  },
  actions: {
    agregarCorteCaja({ getters }, caja) {
      console.log(caja)
      console.log('caja')
      var usuario = getters.usuario;
      var sucursalActiva = getters.sucursal_activa;
      var idFranquicia = getters.usuario.id_franquicia
      var userCaja = getters.usuario
      caja.creado_por = userCaja.id;
      caja.id_usuario_modifico = getters.usuario.id;

      


      caja.id_franquicia = getters.franquicia.id
      caja.id_sucursal = getters.usuario.sucursal_actual
      caja.anio = new Date().getFullYear()

      return new Promise((resolve) => {
        db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.CORTES_CAJA)
          .add(caja)
          .then(doc => {
            //console.log(doc);
            usuario.info_complementaria.id_corte_actual = doc.id
            usuario.info_complementaria.id_caja_actual = caja.info.caja
            db
            .collection('Usuarios')
            .doc(usuario.id)
            .update({
              ...usuario
            })


            //Inicio agregar a cajas activas del la sucursal
            console.log("TCL: agregarCorteCaja -> doc.id", doc.id)
            console.log("TCL: agregarCorteCaja -> caja.info.caja", caja.info.caja)
            sucursalActiva.cajas_abiertas.push({id_corte:doc.id, id_caja:caja.info.caja })
            db
            .collection('Sucursales')
            .doc(sucursalActiva.id)
            .update({
              ...sucursalActiva
            })
            // Fin agregar a cajas activas del la sucursal

            resolve()
          })
      })
    },

    eliminarCorteStore({ getters }, idCaja) {
      var usuario = getters.usuario;
      var sucursalActiva = getters.sucursal_activa;
      // console.log('TCL: ELIMINAR sucursalActiva',sucursalActiva);
      // console.log('TCL: ELIMINAR idCaja: ',idCaja);
      return new Promise((resolve) => {
        usuario.info_complementaria.id_corte_actual = null
        usuario.info_complementaria.id_caja_actual = null
        db
        .collection('Usuarios')
        .doc(usuario.id)
        .update({
          ...usuario
        })

        for (var key in sucursalActiva.cajas_abiertas) {
            var item = sucursalActiva.cajas_abiertas[key];
            if(item.id_caja == idCaja){
              console.log('SE ELIMINAAA....', key)
              sucursalActiva.cajas_abiertas.splice(key, 1);
            }
        }

        db
        .collection('Sucursales')
        .doc(sucursalActiva.id)
        .update({
          ...sucursalActiva
        })

        resolve()
      })
    },
    
    actualizarCaja({getters}, caja) {
      var idFranquicia = getters.usuario.id_franquicia
      console.log('actualizarCaja')
      console.log(caja)
      caja.id_usuario_modifico = getters.usuario.id;
      return new Promise((resolve) => {
        db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(idFranquicia)
        .collection(FS_COLLECTIONS.CORTES_CAJA)
        .doc(caja.id)
        .update(caja)
        .then(() => {
          resolve()
        })
      })
    },

    cargaIndicesCortesCaja({getters,commit}, anio){
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS).
          doc(getters.franquicia.id).
          collection(FS_COLLECTIONS.CORTES_CAJA_INDICES).doc(anio)
          docPath.onSnapshot(doc => {
            resolve()
            commit('ASIGNA_INDICES_CORTES_CAJA',doc.data());
          })
      });
    },

    cargarCaja({ commit, getters }, idCaja) {
      var idFranquicia = getters.usuario.id_franquicia
      return new Promise((resolve) => {
        let docPath = db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(idFranquicia)
        .collection(FS_COLLECTIONS.CORTES_CAJA)
        .doc(idCaja)
        docPath.onSnapshot(doc => {
          commit('ASIGNA_CAJA', doc.data())
          resolve(doc.data())
        })
      })
    },
    async obtenerCortesCajaFiltrados({getters},filtros) {

      const fechaDel = filtros.filtro1.fecha.del.fecha
      const fechaAl = filtros.filtro1.fecha.al.fecha
      const campo = 'info.fecha'
      let docRef = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.CORTES_CAJA).where(campo,'>=',fechaDel).where(campo,'<=',fechaAl)
      docRef = obtenerFiltrosAdicionalesCortesCaja(docRef,filtros)
      
      return await handleGetColecction(docRef)

    }
    

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/cajas/cortes_caja.js